export default {
  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(0.5, 0.5)`)
      .style('font-family', 'roboto')
      .attr('cursor', 'default')

      if(this.title.display == 'Y') {
        let main = this.title.main
        this.canvasForms
        .append('text')
        .attr('x', main.x) .attr('y', main.y + main.tSize*0.75)
        .attr('font-size', main.tSize).attr('fill', main.tColor)
        .attr('text-anchor', main.align)
        .text(main.name)

        let sub = this.title.sub
        this.canvasForms
        .append('text')
        .attr('x', sub.x) .attr('y', sub.y + sub.tSize*0.75)
        .attr('font-size', sub.tSize).attr('fill', sub.tColor)
        .attr('text-anchor', sub.align)
        .text(sub.name)
      }

      this.draw_ChartCanvas() 
      if(this.timeline.display == 'Y') this.draw_Timeline() 
      this.chart_Controller()

      // Sundries
      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },

  }
}